import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Loader = ({isFetching = true, isFullscreen = false, message = '', style}) => {
  if (!isFetching) {
    return null;
  }

  return (
    <div className={classNames({'loading-overlay': isFullscreen})} style={style}>
      <div data-testid="loader" data-component="Loader">
        <div className="loader-spinner">
          <div className="loader-dot1" />
          <div className="loader-dot2" />
        </div>
        {message.length > 0 && (
          <div data-testid="loader-message" className="message">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

Loader.propTypes = {
  message: PropTypes.string,
  isFetching: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  style: PropTypes.object,
};

Loader.defaultProps = {
  message: '',
  isFetching: true,
  isFullscreen: false,
  style: undefined,
};

export default Loader;
